<template>
  <select class="modern-select"
          :disabled="disabled"
          v-bind:value="value"
          v-on:input="$emit('input', $event.target.value)"
  >
    <slot>
      <option v-for="(opt, idx) in options" :key="idx" :value="opt[optionValueKey]">
        {{ opt[optionLabelKey] || opt[optionValueKey] }}
      </option>
    </slot>
  </select>
</template>

<script lang="js">
export default {
  name: 'ModernSelect',
  props: {
    value: null,
    options: {
      type: Array,
      required: true,
      default: () => [],
    },
    optionLabelKey: {
      type: String,
      required: false,
      default: () => 'label',
    },
    optionValueKey: {
      type: String,
      required: false,
      default: () => 'value',
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
};
</script>

<style scoped lang="stylus" />
